import * as React from 'react';
import HomePage from './pages/home/HomePage';
import AppMenu from './shared-components/menu/AppMenu';
import Drawer from '@mui/material/Drawer';
import { useSelector, useDispatch } from 'react-redux';
import { toggleDrawer } from './shared-components/settings-panel/store/settingsSlice';
import SettingsPanel from './shared-components/settings-panel/SettingsPanel';
import AboutModal from './shared-components/about-modal/AboutModal';


function App() {

    const isDrawerOpened = useSelector((state) => state.settings.isDrawerOpened);
    const dispatch = useDispatch();

    const openCloseDrawer = (event, reason) => {

        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        dispatch(toggleDrawer());
    };



    return (
        <div className="flex flex-col">
            <nav className="bg-gray-800 p-2 mt-0 fixed w-full z-10 top-0 shadow-lg">
                <div className="container mx-auto flex flex-wrap items-center">
                    <div className="flex w-full md:w-1/2 justify-center md:justify-start text-white font-extrabold">
                        <a className="text-white no-underline hover:text-white hover:no-underline" >
                            <span className="text-2xl pl-2"><i className="em em-grinning"></i> Let's learn morse code!</span>
                        </a>
                    </div>
                    <div className="flex w-full pt-2 content-center justify-between md:w-1/2 md:justify-end">
                        <AppMenu />
                    </div>
                </div>
            </nav>
            <main className="container mx-auto bg-white mt-16 p-2" >
                <HomePage />
            </main>

            <Drawer
                anchor={"bottom"}
                open={isDrawerOpened}
                onClose={ openCloseDrawer }
            >
                <SettingsPanel />
            </Drawer>

            <AboutModal />
        </div>
    );
}

export default App;
